import building from "../assets/building.jpg"

export const order = ["historical", "modern", "dome"]

export const buildings = {
  modern: {
    name: "корпус нового музея",
    geometry: "B2",
    position: [22.9, 1.98 + 0.07, 15.88],
    // position: [22.9, 3.03, 15.88],
    // 3,0310632992
  },
  dome: {
    geometry: "B3",
    // position: [22.71, 2.71, 15.98],
    // position: [22.71, 2.05, 15.98],
    position: [22.71, 2.05, 15.98],
    name: "купол",
  },
  "modern-roof": {
    geometry: "Roof",
    position: [19.59, 3.44 + 0.07, 16.02],
    // position: [19.59, 3.44 + 1.05, 16.02],
  },
  historical: {
    name: "историческое здание",
    geometries: ["B1-B1", "B1-Roof", "B1-Roof_1"],
    position: [16.59, 6, 11.84],
  },
  bg: {
    geometries: ["BG_1", "BG-bg"],
    position: [-12.94, 1.25, 39.49],
  },
  door: {
    geometry: "Door",
    position: [15.11, 0.71, 30.5],
  },
}

export const texts = {
  historical: {
    heading: "историческое здание",
    text: [
      "За стенками ларца обнаруживается лаконичная и строгая клетка — монолитный каркас нового музея, выложенный белым глазурованным кирпичом, который на некоторых участках складывается в орнамент",
      "В монолитную рамку нового корпуса вложен украшенный сводчатый объем — «рожок», главная ценность музейного комплекса. Под этим высоким сводом, покрытым светлой керамической плиткой-чешуей, хранится собрание царского оружия, давшее имя всей коллекции.",
    ],
  },
  modern: {
    heading: "корпус нового музея",
    text: [
      "За стенками ларца обнаруживается лаконичная и строгая клетка — монолитный каркас нового музея, выложенный белым глазурованным кирпичом, который на некоторых участках складывается в орнамент",
      "В монолитную рамку нового корпуса вложен украшенный сводчатый объем — «рожок», главная ценность музейного комплекса. Под этим высоким сводом, покрытым светлой керамической плиткой-чешуей, хранится собрание царского оружия, давшее имя всей коллекции.",
    ],
    pic: building,
  },
  dome: {
    heading: "Внутренний купол",
    text: [
      "Именно архитектурная форма— новое здание, заключенное в периметр исторического,— определяет ассоциативный образ музея. Заключение одного в другое, многократно повторенная вложенность и создает множественность пространств, которые всегда определяются двумя разными сущностями (7-10).",
      "Внешняя оболочка, которая находится в контакте с окружающим миром,—историческое здание Средних торговых рядов— это резной костяной ларец. Он скрывает сокровища от посторонних глаз, но своей богатой фактурой и декоративностью говорит о высокой ценности хранящихся в нем вещей (6).",
      "За стенками ларца обнаруживается лаконичная и строгая клетка— монолитный каркас нового музея, выложенный белым глазурованным кирпичом, который на некоторых участках складывается в орнамент (11-12, 14).",
      "Именно архитектурная форма— новое здание, заключенное в периметр исторического,— определяет ассоциативный образ музея. Заключение одного в другое, многократно повторенная вложенность и создает множественность пространств, которые всегда определяются двумя разными сущностями (7-10).",
    ],
  },
}

export const camPositions = {
  initial: {
    position: [81.21474759169848, 8.576230458876621, 34.272965475384325],
    rotation: [-0.1426200958511006, 0.691420967327095, 0.09130625876176952],
    target: [41.48243928430011, 1.7534128235876763, -13.241331875843084],
  },
  historical: {
    position: [81.21474759169848, 8.576230458876621, 34.272965475384325],
    rotation: [-0.1426200958511006, 0.691420967327095, 0.09130625876176952],
    target: [41.48243928430011, 1.7534128235876763, -13.241331875843084],
  },
  modern: {
    position: [-1.1578148171247022, 10.15334644481064, 40.19304610131494],
    rotation: [-0.5258661563479392, -0.7189719069794944, -0.3651056830754929],
    target: [39.881738592891374, -13.383123616278167 - 0.3606867684136737],
  },
}

export const colors = {
  bg: "#fdf7ec",
  ambient: "#fff6e1",
  directional: "#fff6e1",
  historical: "#a38334",
  historicalEmissive: "#000",
  dome: "#e8bc4b",
  modern: "#ffe6a6",
  "modern-roof": "#ffe6a6",
  ground: "#e8e1d0",
  shadow: "#c4bba4",
}

export const defaultColor = "#bd9a74"
export const selectionColor = "#BAD6FB"

export const dist = 90

export const multiplier = 1.6

export const lightPosition = {
  x: {
    value: 2,
    min: -100,
    max: 100,
  },
  y: {
    value: 76,
    min: -100,
    max: 100,
  },
  z: {
    value: 100,
    min: -100,
    max: 100,
  },
}
